<template>
  <div
    class="d-flex flex-column w-100 h-100 justify-content-center align-items-center"
  >
    <div class="mw-100 p-5">
      <img class="w-100" src="@/assets/images/404/Img-404-01@2x.png" alt="" />
    </div>
    <div class="font-size-md text-center">
      <div v-html="$t('global.error-message')" v-if="status === 'invite'"></div>
      <i18n :path="getWording()" tag="div" v-else>
        <template v-slot:click v-if="status">
          <a href="javascript:void(0)" @click="goLogin">{{
            $t("error.click-here")
          }}</a>
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import commonTool from '../utils/commonTool';

export default {
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  methods: {
    getWording() {
      switch (this.status) {
        case 'login':
          return 'error.login-fail';
        case 'accessTokenInvalid':
          return 'error.access-token-invalid';
        default:
          return 'error.page-not-found';
      }
    },
    goLogin() {
      commonTool.login(this.$route.query.path);
    },
  },
};
</script>
